import { TeamMember } from '../types';

export const team: TeamMember[] = [
  {
    name: 'tim000x3',
    title: 'Executive Producer',
    weebTitle: 'Mad Scientist / Professional Overthinker',
    role: 'Creator of CommercialBreaker, Toonami Tools, and pretty much everything else not already credited. Also made this website because apparently having one project wasn\'t enough.',
    github: 'https://github.com/tim000x3'
  },
  {
    name: 'mugiwaralufy',
    title: 'Lineup Wizard',
    weebTitle: 'Captain of the Going Merry / Regex Sorcerer',
    role: 'Creator of merger, LineupPrep, and MultiLineup. Solved a very complicated traveling salesman problem and does it pretty well. Makes the impossible lineups possible through dark regex magic we don\'t fully understand.',
    github: undefined
  },
  {
    name: 'lazydeadsnail',
    title: 'Data Scraping Ninja',
    weebTitle: 'Shadow Clone Master',
    role: 'Creator of ToonamiChecker. Scrapes data from the internet faster than Naruto runs.',
    github: undefined
  },
  {
    name: 'aislynne',
    title: 'Tea Sommelier & Snack Coordinator',
    weebTitle: 'Keeper of Morale / Bringer of Sustenance',
    role: 'Keeps the team caffeinated and fed during 3 AM coding sessions. The true MVP.',
    github: undefined
  }
];

/**
 * Special thanks section
 */
export const specialThanks = [
  { name: 'Steve Blum', role: 'Voice of TOM (Also for signing the keyboard used to make this program)' },
  { name: 'Fabrice Bellard', role: 'Creator of FFmpeg' },
  { name: 'Cartoon Network', role: 'Creator of Toonami' },
  { name: 'My Parents', role: 'Hi Mom and Dad!' },
  { name: 'OpenAI & Anthropic', role: 'AI assistants that edited code and docs' },
  { name: 'Caffeine', role: 'The real hero' },
  { name: 'Our sanity', role: 'Rest in peace' }
];
